module.exports = __webpack_public_path__ + "d312efc8e2b0a790e09fd974e0de7143.pdf";